import { modalSlice } from 'redux/slices/common/modal-slice';

export const { showModal, hideModal } = modalSlice.actions;
